import { useCallback, useEffect, useState } from "react";
import { api } from "../api/client";
import { useAuth } from "../context/AuthContext";

const REFRESH_EVENT = "orders:refresh-open-count";

/**
 * Von der Seite "Neue Bestellungen" nach dem Laden/Abschließen aufzurufen,
 * damit das Badge sofort aktualisiert wird, statt bis zu 60s auf das nächste
 * periodische Polling zu warten.
 */
export function notifyOpenOrdersChanged(): void {
  window.dispatchEvent(new Event(REFRESH_EVENT));
}

/**
 * Anzahl offener Bestellungen fürs Badge neben dem Menüpunkt "Neue
 * Bestellungen" - gleiches Prinzip wie useOpenRequestsCount (Anfragen). Wird
 * nur abgefragt, wenn der Benutzer "orders.manage" besitzt (sonst 0, ohne
 * API-Aufruf); danach alle 60 Sekunden, sodass eine neue Bestellung ohne
 * Neuladen der Seite als Zähler im Menü erscheint.
 */
export function useOpenOrdersCount(): number {
  const { hasPermission } = useAuth();
  const canView = hasPermission("orders.manage");
  const [count, setCount] = useState(0);

  const load = useCallback(() => {
    if (!canView) {
      setCount(0);
      return;
    }
    api
      .get<{ count: number }>("/api/orders/open-count")
      .then((r) => setCount(r.count))
      .catch(() => {});
  }, [canView]);

  useEffect(() => {
    load();
    const interval = setInterval(load, 60_000);
    window.addEventListener(REFRESH_EVENT, load);
    return () => {
      clearInterval(interval);
      window.removeEventListener(REFRESH_EVENT, load);
    };
  }, [load]);

  return count;
}
